export default __webpack_public_path__ + "src/components/pages/login/customers/c5c05fbecfa3e46d156a272e6980e8e7.png";